import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const CarouselWrapper = styled.div`
  .slick-slider {
    .slick-list {
      padding-bottom: 0 !important;
    }
    .slick-dots {
      top: unset;
      bottom: 60px !important;

      @media ${(props) => props.theme.device.tablet} {
        bottom: 40px !important;
      }

      li {
        & button::before {
          content: '';
          border-color: ${({ theme }) => theme.colors.white} !important;
          color: ${({ theme }) => theme.colors.white} !important;
        }
      }
      li.slick-active {
        & button::before {
          background-color: ${({ theme }) => theme.colors.white} !important;
        }
      }
    }
    .slick-arrow {
      top: unset;
      bottom: 55px !important;

      @media ${(props) => props.theme.device.tablet} {
        bottom: 35px !important;
      }

      svg {
        stroke: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;

export const Cover = styled.div`
  width: 100%;
  height: 500px;
  background: url(${({ src }) => getUrlWithToken(src)});
  background-position: center center;
  background-size: cover;
  @media ${(props) => props.theme.device.tablet} {
    height: 651px;
  }
`;

export const Overlay = styled.div`
  width: 100%;
  height: inherit;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.67) 39.12%,
    rgba(104, 104, 104, 0) 103.19%
  );
`;
export const Date = styled.p`
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 16px;
`;

export const Title = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  max-width: 50%;
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 16px;

  @media ${(props) => props.theme.device.tablet} {
    max-width: 83%;
  }
`;

export const Body = styled.div`
  max-width: 33%;
  color: ${({ theme }) => theme.colors.white};

  > div {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    overflow: hidden;
  }

  @media ${(props) => props.theme.device.tablet} {
    max-width: 81%;
    margin-bottom: 32px;

    > div {
      -webkit-line-clamp: 12;
    }
  }
`;

export const BtnWrapper = styled.div`
  position: absolute;
  bottom: 42px;

  @media ${(props) => props.theme.device.mobileL} {
    width: calc(100vw - 32px);
    bottom: 80px;
  }

  > button {
    @media ${(props) => props.theme.device.tablet} {
      width: 100%;
    }
  }
`;
